// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"6443ff00","498":"73e3872b","703":"44b729cb","787":"547ada48"}[chunkId] + ".chunk.js";
};